import axios from "axios";
import CustomInterceptors from "@/api/GAInterceptors";

const instanceSmartLogistics = axios.create({
  baseURL: process.env.VUE_APP_API_URL
});

instanceSmartLogistics.interceptors.request.use(CustomInterceptors.GAInterceptors);

instanceSmartLogistics.interceptors.response.use(response => {
  return response;
}, CustomInterceptors.GAInterceptorsOnError);

export default instanceSmartLogistics;